import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import CircularJSON from 'circular-json';

import aionAppReducer from './aionAppReducer';
import onboardingAppReducer from './onboardingAppReducer';
import bankingAppReducer from './bankingAppReducer';
import bookkeepingAppReducer from './bookkeepingAppReducer';
import creditAppReducer from './creditAppReducer';
import receivablesAppReducer from './receivablesAppReducer';
import userDefaultsReducer from './userDefaultsReducer';

// Utils
import { loadState, saveState } from '../Utils/localStorage';

const rootReducer = combineReducers({
	aionAppReducer,
	onboardingAppReducer,
	bankingAppReducer,
	creditAppReducer,
	receivablesAppReducer,
	userDefaultsReducer,
	bookkeepingAppReducer
});

// Create a middleware to handle cross-tab synchronization
const crossTabSyncMiddleware = store => next => action => {
	const result = next(action);

	if (action.type !== 'SYNC_STATE_FROM_STORAGE') {
		const state = store.getState();
		saveState(state);
		localStorage.setItem('redux_state_updated', Date.now().toString());
	}

	return result;
};

// Add a new reducer case to handle the sync action
const crossTabSyncReducer = (state, action) => {
	if (action.type === 'SYNC_STATE_FROM_STORAGE') {
		return {
			...state,
			...action.payload
		};
	}
	return state;
};

// Wrap the root reducer to apply the sync
const syncedRootReducer = (state, action) => {
	const intermediateState = rootReducer(state, action);
	return crossTabSyncReducer(intermediateState, action);
};

const persistedState = loadState();

const store = createStore(
	syncedRootReducer,  // Use syncedRootReducer instead of rootReducer
	persistedState,
	applyMiddleware(thunk, crossTabSyncMiddleware)
);

// Listen for changes from other tabs
window.addEventListener('storage', (event) => {
	console.log("storage updated", event.key);
	if (event.key === 'redux_state_updated') {
		const newState = loadState();
		if (newState) {
			store.dispatch({ type: 'SYNC_STATE_FROM_STORAGE', payload: newState });
		}
	}
});

export default store;